import * as React from 'react';
import { Helmet } from 'react-helmet';

interface Ctx {
  parts: Array<string>;
  setTitle: React.Dispatch<React.SetStateAction<Array<string>>>;
}

const Context = React.createContext<Ctx>({ parts: [], setTitle: () => {} });

export function useTitle(title: string) {
  const { setTitle } = React.useContext(Context);

  React.useEffect(() => {
    setTitle((parts) => [title, ...parts]);
    return () => {
      setTitle((parts) => {
        const currIndex = parts.indexOf(title);
        const newTitle = [...parts];
        newTitle.splice(currIndex, 1);
        return newTitle;
      });
    };
  }, [title]);
}

const defaultTitle = 'Microsoft for Startups Founders Hub';

export function TitleProvider({ children }: { children: React.ReactNode }) {
  const [parts, setTitle] = React.useState<Array<string>>([]);
  return (
    <Context.Provider value={{ parts, setTitle }}>
      <Helmet defaultTitle={defaultTitle} titleTemplate={`%s • ${defaultTitle}`}>
        <title>{parts.join(' • ')}</title>
      </Helmet>
      {children}
    </Context.Provider>
  );
}
